import { Link } from "react-router-dom";
import { Seo, Eyebrow, ArrowLink } from "@/components/site/primitives";
import { Stagger, Item } from "@/components/site/motion";
import { PageHero, Section } from "@/components/site/pageparts";
import { POSTS } from "@/data/blog";

const fmt = (d) => new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });

export default function Blog() {
  return (
    <div data-testid="blog-page">
      <Seo title="Blog" description="Research-tone essays and lab notes from DataFrontier on memory as infrastructure." />
      <PageHero
        eyebrow="Blog · Lab notes"
        title="Notes from a lab that ships."
        lead="Short, first-principles essays on retrieval, attribution, determinism and sovereignty. Numbers over adjectives. We publish the harness, not just the headline."
      >
        <ArrowLink href="/rss.xml" external>Subscribe via RSS</ArrowLink>
      </PageHero>
      <Section>
        <Stagger className="divide-y divide-white/10 border-y border-white/10">
          {POSTS.map((p) => (
            <Item key={p.id}>
              <Link
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="group grid gap-4 py-10 md:grid-cols-12 md:gap-8"
              >
                <div className="md:col-span-3">
                  <div className="flex items-center gap-3 font-mono text-xs text-mist">
                    <span className="text-saffron">{p.id}</span>
                    <span>{fmt(p.date)}</span>
                  </div>
                  <div className="mt-2 font-mono text-[11px] text-mist">{p.readTime} read</div>
                </div>
                <div className="md:col-span-9">
                  <h2 className="font-serif text-2xl leading-snug text-bone transition-colors duration-300 group-hover:text-saffron md:text-3xl">
                    {p.title}
                  </h2>
                  <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-mist">{p.abstract}</p>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {p.tags.map((t) => (
                      <span key={t} className="border border-white/12 px-2.5 py-1 font-mono text-[11px] uppercase tracking-wide text-mist">
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            </Item>
          ))}
        </Stagger>
      </Section>
    </div>
  );
}
